import React, { useEffect } from 'react';
import cancel from './../../../static/icons/cancel.svg';
import PropTypes from 'prop-types';
import styles from './confirmation.module.scss';

export const Confirmation = ({
  children,
  message,
  onClose,
  actions,
  title,
  hideBody,
  className,
  confirmAdjust,
  customSize
}) => {
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  const setActionType = (type) => {
    if (type === 'p') {
      return 'confirm';
    } else if (type === 's') {
      return 'cancel float-right';
    } else if (type === 'c') {
      return `confirm ${styles.success_align}`;
    } else if (type === 'b') {
      return `back`;
    }
    return ''
  };

  return (
    <div
      className={className ? `${styles.popup} ${className}` : styles.popup}
      id="modalWindow"
      data-testid="modalWindow"
    >
      {/* <div className="popup_inner"> */}
      <div className={`${styles.ws_modal_xl} ${styles.delete_conf} ${styles.confirmAdjustCls} `}>
        <div className={`modal-dialog modal-dialog-scrollable modal-dialog-centered  ${(confirmAdjust === true) ? styles.confirmAdjustCls : ''} ${(customSize)?customSize:''}`}>
          <div className={`modal-content rounded-0 ${styles.ws_modal_content}`}>
            <div className={`modal-header ${styles.ws_modal_header}`}>
              <h5 className={`modal-title ${styles.custom_title}`}>{title || 'ALERT'}</h5>
              <button to="#" data-testid="close" onClick={onClose} className={`${styles.close_btn}`}>
                <img src={cancel} alt="Close" />
              </button>
            </div>
            {(message || children) && (
              <div
                className={`modal-body ${styles.ws_modal_body} ${(confirmAdjust === true) ? styles.scrollApply : ''}`}
                style={{ display: hideBody ? 'none' : 'block' }}
              >
                {message ? <p>{message}</p> : children}
              </div>
            )}
            {actions && actions.length > 0 && (
              <div className={`modal-footer ${styles.ws_modal_footer}`}>
                {actions.map((a) => (
                  <button
                    key={`action-${a.type}`}
                    to="#"
                    disabled={a.disabled ? a.disabled : false}
                    data-dismiss="modal"
                    onClick={a.func}
                    className={`btn btn-primary ${setActionType(a.type)}`}
                  >
                    {a.title}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

Confirmation.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string,
  actions: PropTypes.array,
  children: PropTypes.any,
  hideBody: PropTypes.bool,
  className: PropTypes.string,
};
